import { containerStyles } from "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

containerStyles.container = {
    css: css`
        margin-top: 25px;
        position: relative;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 20px;
                `,
                css`
                    margin-top: 20px;
                `,
                null,
                null,
                null,
            ])}
    `,
};

containerStyles.leftGridItem = {
    width: [12, 12, 12, 8, 8],
    css: css`
        & > div > div:not(:last-child) {
            padding-bottom: 0px;
            margin-bottom: 16px;
        },
        & {
           margin-bottom: 300px !important;
            @media (max-width: 992px) {
                margin-bottom: 0px !important;
            }
        }
    `,
};
containerStyles.spaceGridItem = {
    css: css`
        & {
            display: none;
        }
    `,
};
containerStyles.rightGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        & > div > *:not(:last-child) {
            margin-bottom: 10px;
        }
        & > div {
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    position: sticky;
                    top: 180px;                    
                `,
                css`
                    position: sticky;
                    top: 180px;
                `,
            ])}
        }
    `,
};
